import classNames from "classnames";
import moment from "moment";
import React from "react";
import {
	EAnnex6RecordState,
	TAnnex6Record,
} from "../../../../../redux/app/annex6/@types";
import { TAnnex6GroupJ6 } from "../../../../../redux/app/annex6/groups/group-j";
import { marpolUtils } from "redux/app/marpol";
import Annex6Previewer from "../Annex6Previewer";
import Annex6TableRows, { Annex6TableColumns } from "../Annex6TableRows";

type OwnProps = {
	annex6Record: TAnnex6Record;
	isStrikedOff?: boolean;
};
type ANNEX6J6PreviewProps = React.PropsWithChildren<OwnProps>;
function ANNEX6J6Preview(props: ANNEX6J6PreviewProps) {
	const record = props.annex6Record as TAnnex6GroupJ6;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY"
	);
	const dateOfOriginalOperation = moment(
		record.itemJ6.dateOfOriginalOperation,
		"YYYY-MM-DD"
	).format("DD-MMM-YYYY");

	function renderMain() {
		return (
			<>
				<Annex6TableRows
					record={record}
					tableRows={[
						[dateOfOriginalOperation, "J", "-", renderItemMain()],
						[...renderMissedPlaceholder()],
						[null, null, "NOTE", record.remarks],
					]}
				/>
				{renderMissedRecord()}
			</>
		);
	}

	function renderItemMain() {
		return (
			<h4 className="font-medium uppercase">
				ENTRY PERTAINING TO AN EARLIER MISSED OPERATIONAL ENTRY
				{record.itemJ6.receiptAttachment &&
				record.itemJ6.receiptAttachment !== " " ? (
					<>
						<br />
						CORRECTION NOTE:{" "}
						<a
							href={marpolUtils.getAttachmentURL(
								record.itemJ6.receiptAttachment,
								record.id,
								record._rev
							)}
							download={record.itemJ6.receiptAttachment}
						>
							{" "}
							{record.itemJ6.receiptAttachment}
						</a>
					</>
				) : null}
			</h4>
		);
	}

	function renderMissedPlaceholder(): Annex6TableColumns {
		const canShowPlaceholder =
			record.itemJ6.isAnMissedEntryRecord && !record.itemJ6.missedRecord;
		if (!canShowPlaceholder) return [null, null, null, null];

		const content = (
			<h4 className="font-medium text-gray-500 uppercase">
				<div className="flex flex-row items-center justify-center p-6 px-12 font-medium text-center bg-gray-100 border-2 border-gray-400 border-dashed">
					<div>MISSED ENTRY WILL APPEAR HERE</div>
					<span className="ml-6 text-gray-400 bp3-icon bp3-icon-time"></span>
				</div>
			</h4>
		);

		return [
			operationDate,
			<div className="text-gray-500">?</div>,
			<div className="text-gray-500">?</div>,
			content,
		];
	}

	function renderMissedRecord() {
		if (!record.itemJ6.missedRecord) return null;
		return (
			<Annex6Previewer
				annex6Record={{
					...record.itemJ6.missedRecord,
					selectedDate: record.selectedDate,
					state: props.isStrikedOff
						? EAnnex6RecordState.STRIKED_OFF
						: record.itemJ6.missedRecord.state,
				}}
			/>
		);
	}

	return renderMain();
}

export default ANNEX6J6Preview;
